/**
 * Arquivo de reducer para o whitelabel.
 * Gerencia o estado relacionado ao whitelabel na aplicação.
 * Utiliza Redux para atualizar o estado com base nas ações despachadas.
 */

const initialState = {
  ivcla_txds_htmlcoverlogin: "",
  ivcla_txds_htmlredessociaislogin: "",
  ivcla_txds_htmlrodape: "",
  ivcla_txds_htmltopo: "",
  ivcla_vcds_titulologin: "",
  ivcla_vcds_titulomenu: "",
  ivcla_vcds_urliconemenu: "",
  ivcla_vcds_urllogomarcalogin: "",
  ivcla_vcds_urllogomarcamenu: "",
  ivcla_vcds_urllogomarcanavegacao: "",
  ivcla_vcnu_corbackground: "",
  ivcla_vcnu_corbackgroundmenu: "",
  ivcla_vcnu_corbotaoaccesscard: "",
  ivcla_vcnu_corbotaoagendar: "",
  ivcla_vcnu_corbotaoalerta: "",
  ivcla_vcnu_corbotaocadastrar: "",
  ivcla_vcnu_corbotaocancelar: "",
  ivcla_vcnu_corbotaodefault: "",
  ivcla_vcnu_corbotaodeletar: "",
  ivcla_vcnu_corbotaoeditar: "",
  ivcla_vcnu_corbotaoesqueceusenha: "",
  ivcla_vcnu_corbotaoimprimir: "",
  ivcla_vcnu_corbotaopagar: "",
  ivcla_vcnu_corbotaosaibamais: "",
  ivcla_vcnu_corbotaoservico: "",
  ivcla_vcnu_corbotaosubmit: "",
  ivcla_vcnu_corbotaovoltar: "",
  ivcla_vcnu_corcarddesabilitado: "",
  ivcla_vcnu_corcardhabilitado: "",
  ivcla_vcnu_corprimaria: "",
  ivcla_vcnu_corsecundaria: "",
  ivcla_vcnu_cortextomenu: "",
  ivcla_vcnu_cortextosilenciadomenu: "",
};

export default function (state = initialState, action: any) {
  switch (action?.type) {
    case "CHANGE_LAYOUT":
      return {
        ...state,
        ivcla_txds_htmlcoverlogin: action.payload.ivcla_txds_htmlcoverlogin,
        ivcla_txds_htmlredessociaislogin: action.payload.ivcla_txds_htmlredessociaislogin,
        ivcla_txds_htmlrodape: action.payload.ivcla_txds_htmlrodape,
        ivcla_txds_htmltopo: action.payload.ivcla_txds_htmltopo,
        ivcla_vcds_titulologin: action.payload.ivcla_vcds_titulologin,
        ivcla_vcds_titulomenu: action.payload.ivcla_vcds_titulomenu,
        ivcla_vcds_urliconemenu: action.payload.ivcla_vcds_urliconemenu,
        ivcla_vcds_urllogomarcalogin: action.payload.ivcla_vcds_urllogomarcalogin,
        ivcla_vcds_urllogomarcamenu: action.payload.ivcla_vcds_urllogomarcamenu,
        ivcla_vcds_urllogomarcanavegacao: action.payload.ivcla_vcds_urllogomarcanavegacao,
        ivcla_vcnu_corbackground: action.payload.ivcla_vcnu_corbackground,
        ivcla_vcnu_corbackgroundmenu:  action.payload.ivcla_vcnu_corbackgroundmenu,
        ivcla_vcnu_corbotaoaccesscard: action.payload.ivcla_vcnu_corbotaoaccesscard,
        ivcla_vcnu_corbotaoagendar: action.payload.ivcla_vcnu_corbotaoagendar,
        ivcla_vcnu_corbotaoalerta: action.payload.ivcla_vcnu_corbotaoalerta,
        ivcla_vcnu_corbotaocadastrar: action.payload.ivcla_vcnu_corbotaocadastrar,
        ivcla_vcnu_corbotaocancelar: action.payload.ivcla_vcnu_corbotaocancelar,
        ivcla_vcnu_corbotaodefault: action.payload.ivcla_vcnu_corbotaodefault,
        ivcla_vcnu_corbotaodeletar: action.payload.ivcla_vcnu_corbotaodeletar,
        ivcla_vcnu_corbotaoeditar: action.payload.ivcla_vcnu_corbotaoeditar,
        ivcla_vcnu_corbotaoesqueceusenha: action.payload.ivcla_vcnu_corbotaoesqueceusenha,
        ivcla_vcnu_corbotaoimprimir: action.payload.ivcla_vcnu_corbotaoimprimir,
        ivcla_vcnu_corbotaopagar: action.payload.ivcla_vcnu_corbotaopagar,
        ivcla_vcnu_corbotaosaibamais:action.payload.ivcla_vcnu_corbotaosaibamais,
        ivcla_vcnu_corbotaoservico: action.payload.ivcla_vcnu_corbotaoservico,
        ivcla_vcnu_corbotaosubmit: action.payload.ivcla_vcnu_corbotaosubmit,
        ivcla_vcnu_corbotaovoltar: action.payload.ivcla_vcnu_corbotaovoltar,
        ivcla_vcnu_corcarddesabilitado: action.payload.ivcla_vcnu_corcarddesabilitado,
        ivcla_vcnu_corcardhabilitado: action.payload.ivcla_vcnu_corcardhabilitado,
        ivcla_vcnu_corprimaria: action.payload.ivcla_vcnu_corprimaria,
        ivcla_vcnu_corsecundaria: action.payload.ivcla_vcnu_corsecundaria,
        ivcla_vcnu_cortextomenu: action.payload.ivcla_vcnu_cortextomenu,
        ivcla_vcnu_cortextosilenciadomenu:action.payload.ivcla_vcnu_cortextosilenciadomenu,
      };
    default:
      return {
        ...state,
      };
  }
}
